import { createContext, useContext } from "react";
import { C8AttributeId, C8NodeType } from "src/c8-platform/type/node";
import { cnl } from "src/c8-platform/type/value";
import { RefStoreBase } from "./RefStoreBase";

export class RefContainerStore extends RefStoreBase {
	constructor(attributeId: C8AttributeId, nodeType: C8NodeType, nodeUrl: cnl, reportOperations: string) {
		super(attributeId, nodeType, nodeUrl, reportOperations);
	}
}

export const RefContainerStoreContext = createContext<RefContainerStore>(undefined);
export const useRefContainerStore = (): RefContainerStore => useContext(RefContainerStoreContext);